export default __webpack_public_path__ + "static/media/home_polygon_bottom.0e4a9126.svg";